import React from 'react';
import Banner from "./Banner"
import ServicesOne from "./ServicesOne"
import WhyChoose from "./WhyChoose"
import Project from "./Project"
import About from './AboutSection';
import Features from './Features';
import Team from './Team';
import WhyareweSec from './WhyAreWeSec';
import Brand from './Brand';
import Blog from './Blog';
import TestimonialsSection from './TestimonialsSection';
import FAQsection from './FAQsection';
import ScrollVelocity from '../../components/Reactbits/ScrollVelocity';
import OperationalAreas from '../areaMaps/OperationalAreas';
import WhyChoseAs from '../whyChoseAs/index';
import GetAQuote from '../getAQuote/index';
const HomeMain = () => {
	return (
		<React.Fragment>
			<Banner />
			<About />

			{/* <ServicesOne /> */}
			{/* <WhyChoose /> */}
			<Project />
			<ScrollVelocity
				texts={['Cross Dock, Brokerage, Ware Housing,']} 
				velocity={100} 
				className="custom-scroll-text"
			/>

			{/* Operational Areas */}
			<OperationalAreas/>
			{/* Why Choose As */}
			<WhyChoseAs/>
			{/* Get a Quote */}

			<Team/>
			<GetAQuote/>

			{/* <Features /> */}
			{/* <Team/> */}
			{/* <WhyareweSec /> */}
			{/* <FAQsection /> */}
			{/* <TestimonialsSection /> */}
			 {/* <Blog/> */}
		</React.Fragment>
	);
}

export default HomeMain;